<template>
    <div class="centerWidth">
        <!-- <div class="gaokao-nav">
            <span>个人中心 ></span>
            <span>新高考选科测评 ></span>
            <span>开始测试</span>
        </div> -->
        <section class="gaokao-content">
            <div class="my-title">新高考选科测评</div>
            <ul class="gkTest-step">
                <li>
                    <div class="step-con step-on flex zhong center">
                        <div>
                            <img src="../../../image/sub-level-aa.png" />
                            <span>学科水平</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
                </li>
                <li>
                    <div class="step-con step-on flex zhong center">
                        <div>
                            <img src="../../../image/sub-intl-aa.png" />
                            <span>学科兴趣</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/sub-occ-a.png" />
                            <span>职业兴趣</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
                </li>
                <li>
                    <div class="step-con flex zhong center">
                        <div>
                            <img src="../../../image/sub-char-a.png" />
                            <span>职业性格</span>
                        </div>
                    </div>
                </li>
            </ul>
            <p class="test-tit">学科兴趣测试</p>
            <article class="testTwo-con">
                <div
                    class="testTwo-list"
                    v-for="item in question"
                    :key="item.Id"
                >
                    <p
                        class="test-ctxt"
                        :class="{'empty-question': !item.notEmpty}"
                    >{{item.Sort}}.{{item.Title}}{{item.Remark}}</p>
                    <template v-if="item.ImgList.length > 0">
                        <div class="way-testB">
                            <img
                                :src="imgUrl"
                                alt=""
                                v-for="imgUrl in item.ImgList"
                                :key="imgUrl"
                            >
                        </div>
                    </template>
                    <template v-if="item.Type === 1">
                        <ul class="testTwo-ul">
                            <li
                                v-for="answer in item.AnswerList"
                                :key="answer.Id"
                            >
                                <input
                                    type="radio"
                                    :name="'q' + item.Id"
                                    :value="answer.Option"
                                    v-model="item.Option"
                                />
                                <p>{{answer.Option}}.{{answer.Content}}</p>
                            </li>
                        </ul>
                    </template>
                </div>
            </article>
            <div class="test-btn">
                <button
                    class="gaokao-btn"
                    @click="goTesta()"
                >上一步</button>
                <button
                    class="gaokao-btn"
                    @click="goNext()"
                >下一步</button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
        };
    },
    methods: {
        // 上一步
        goTesta() {
            this.$emit('prev');
            // this.$router.push('/gktesta');
        },
        // 下一步
        goNext() {
            this.$emit('next');
            // this.$router.push('/gktestc');
        }
    }
};
</script>

<style scoped>
.test-ctxt.empty-question {
    color: #ff1e00;
    font-weight: bold;
}

.gaokao-nav {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0;
}
.gaokao-nav span {
    font-size: 15px;
    color: #333;
}
.gaokao-nav span:last-child {
    color: #333;
}
/* gaokao-content */
.gaokao-content {
    padding: 0 20px;
    width: 100%;
    height: auto;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 25px;
}

.test-tit {
    font-size: 16px;
    color: #333;
    position: relative;
    padding-left: 20px;
    margin-bottom: 30px;
}
.test-tit::after {
    position: absolute;
    content: '';
    width: 0;
    height: 20px;
    left: 0;
    top: 50%;
    margin-top: -10px;
    border: 2px solid #333;
    border-radius: 50px;
}
/* testTwo-con */
.testTwo-con {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.testTwo-list {
    width: 100%;
    height: auto;
    overflow: hidden;
}
.test-ctxt {
    font-size: 15px;
    color: #333;
    margin-bottom: 25px;
}
.testTwo-ul {
    padding: 0 30px;
    height: auto;
    overflow: hidden;
}
.testTwo-ul li {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 25px;
}
.testTwo-ul li input {
    margin-right: 15px;
}
.testTwo-ul li p {
    font-size: 15px;
    color: #333;
}
.test-btn {
    display: flex;
    align-items: center;
    justify-content: center;
}
.test-btn button {
    margin-left: 20px;
    margin-right: 20px;
}
</style>
